import type { UserInvestmentProfile } from '@fruitful/investment-management';

import { requestBuilder } from '../../http/RequestBuilder';

interface UseUpsertUserInvestmentProfileParams {
    userId: string;
}

const useUpsertUserInvestmentProfile = requestBuilder.mutation<
    UserInvestmentProfile,
    Partial<UserInvestmentProfile>,
    UseUpsertUserInvestmentProfileParams
>({
    endpoint: ({ userId }) => `/api/user/${userId}/investment-profile`,
    method: 'POST',
});

export default useUpsertUserInvestmentProfile;
